/**
 * Do not edit directly
 * Generated on Fri, 09 Aug 2024 18:36:09 GMT
 */


  export const FuelColorBrandPrimary = "#1a1c1c";
  export const FuelColorBrandSecondary = "#54585a";
  export const FuelColorBackgroundActionDefaultBase = "#ffffff";
  export const FuelColorBackgroundActionDefaultHovered = "#f7f7f7";
  export const FuelColorBackgroundActionDefaultPressed = "#f0f0f0";
  export const FuelColorBackgroundActionDefaultSelected = "#f7f7f7";
  export const FuelColorBackgroundActionDefaultSelectedBar = "#eacb00";
  export const FuelColorBackgroundActionPrimaryBase = "#ffde00";
  export const FuelColorBackgroundActionPrimaryHovered = "#eacb00";
  export const FuelColorBackgroundActionPrimaryPressed = "#ceb300";
  export const FuelColorBackgroundActionSecondaryBase = "#ffffff";
  export const FuelColorBackgroundActionSecondaryHovered = "#f7f7f7";
  export const FuelColorBackgroundActionSecondaryPressed = "#dddddd";
  export const FuelColorBackgroundActionTertiaryBase = "rgba(0, 0, 0, 0)";
  export const FuelColorBackgroundActionTertiaryHovered = "#f7f7f7";
  export const FuelColorBackgroundActionTertiaryPressed = "#f0f0f0";
  export const FuelColorBackgroundInteractiveDefaultBase = "#1b1b1b";
  export const FuelColorBackgroundWhite = "#ffffff";
  export const FuelColorBackgroundGray = "#f0f0f0";
  export const FuelColorBackgroundBrand = "#1a1c1c";
  export const FuelColorTextLink = "#1a1c1c";
  export const FuelColorTextLinkHovered = "#666666";
  export const FuelColorTextActionDefault = "#454545";
  export const FuelColorTextActionPrimary = "#000000";
  export const FuelColorTextActionSecondary = "#454545";
  export const FuelColorTextActionTertiary = "#1a1c1c";
  export const FuelColorTextPrimary = "#1b1b1b";
  export const FuelColorTextSecondary = "#454545";
  export const FuelColorTextTertiary = "#666666";
  export const FuelColorTextDisabled = "#b3b3b3";
  export const FuelColorTextBody = "#1b1b1b";
  export const FuelColorTextHeading = "#1b1b1b";
  export const FuelColorTextIcon = "#666666";
  export const FuelColorTextBrandPrimary = "#1a1c1c";
  export const FuelColorFocused = "#1b1b1b";
  export const FuelColorBorderSelected = "#1a1c1c";
  export const FuelColorBorderBase = "#cccccc";
  export const FuelColorBorderLight = "#dddddd";
  export const FuelColorBorderDark = "#b3b3b3";
  export const FuelColorAlertSuccessBackground = "#f4f8f4";
  export const FuelColorAlertSuccessIcon = "#367c2b";
  export const FuelColorAlertSuccessBorder = "#99bd93";
  export const FuelColorAlertErrorBackground = "#fdf6f6";
  export const FuelColorAlertErrorIcon = "#c21020";
  export const FuelColorAlertErrorBorder = "#dd737e";
  export const FuelColorAlertInfoBackground = "#f3f7fb";
  export const FuelColorAlertInfoIcon = "#005db1";
  export const FuelColorAlertInfoBorder = "#7aabd6";
  export const FuelColorAlertWarningBackground = "#fef6ea";
  export const FuelColorAlertWarningIcon = "#f99700";
  export const FuelColorAlertWarningBorder = "#ffbb52";
  export const FuelColorGray50 = "#f7f7f7";
  export const FuelColorGray100 = "#f0f0f0";
  export const FuelColorGray200 = "#dddddd";
  export const FuelColorGray300 = "#cccccc";
  export const FuelColorGray400 = "#b3b3b3";
  export const FuelColorGray500 = "#919191";
  export const FuelColorGray600 = "#767676";
  export const FuelColorGray700 = "#666666";
  export const FuelColorGray800 = "#454545";
  export const FuelColorGray900 = "#333333";
  export const FuelColorGray1000 = "#1b1b1b";
  export const FuelColorYellow50 = "#fff8cd";
  export const FuelColorYellow100 = "#fff29a";
  export const FuelColorYellow200 = "#ffde00";
  export const FuelColorYellow300 = "#eacb00";
  export const FuelColorYellow400 = "#ceb300";
  export const FuelColorYellow500 = "#a69100";
  export const FuelColorYellow600 = "#877600";
  export const FuelColorYellow700 = "#756600";
  export const FuelColorYellow800 = "#504500";
  export const FuelColorYellow900 = "#3b3400";
  export const FuelColorYellow1000 = "#201c00";
  export const FuelColorGreen50 = "#f4f8f4";
  export const FuelColorGreen100 = "#ebf2ea";
  export const FuelColorGreen200 = "#d2e1cf";
  export const FuelColorGreen300 = "#bbd3b7";
  export const FuelColorGreen400 = "#99bd93";
  export const FuelColorGreen500 = "#699e61";
  export const FuelColorGreen600 = "#438539";
  export const FuelColorGreen700 = "#367c2b";
  export const FuelColorGreen800 = "#224e1b";
  export const FuelColorGreen900 = "#1a3b14";
  export const FuelColorGreen1000 = "#0e1f0b";
  export const FuelColorBlack = "#000000";
  export const FuelColorWhite = "#ffffff";
  export const FuelColorJdGreen = "#367c2b";
  export const FuelColorJdYellow = "#ffde00";
  export const FuelColorJdCharcoal = "#54585a";
  export const FuelColorJdConstructionYellow = "#f2a900";
  export const FuelColorChartBrandGreen = "#367c2b";
  export const FuelColorChartBrandYellow = "#ffde00";
  export const FuelColorChartCoriander = "#bab994";
  export const FuelColorChartNightRider = "#333333";
  export const FuelColorChartYellowSea = "#ffb000";
  export const FuelColorChartAthensGrey = "#e5e6e6";
  export const FuelColorChartRollingStone = "#717a80";
  export const FuelColorChartCanaryYellow = "#fff494";
  export const FuelColorChartOliveGreen = "#a3ae58";
  export const FuelChipColorBackgroundSelected = "#454545";
  export const FuelSpacing0 = "0rem";
  export const FuelSpacing1 = "0.25rem";
  export const FuelSpacing2 = "0.5rem";
  export const FuelSpacing3 = "0.75rem";
  export const FuelSpacing4 = "1rem";
  export const FuelSpacing6 = "1.5rem";
  export const FuelSpacing8 = "2rem";
  export const FuelSpacing10 = "2.5rem";
  export const FuelSpacing12 = "3rem";
  export const FuelSpacing16 = "4rem";
  export const FuelBorderRadiusBase = ".25rem";
  export const FuelBorderRadiusNone = "0";
  export const FuelBorderRadiusSm = ".125rem";
  export const FuelBorderRadiusMd = ".25rem";
  export const FuelBorderRadiusLg = ".5rem";
  export const FuelBorderRadiusXl = ".75rem";
  export const FuelBorderRadius2xl = "1rem";
  export const FuelBorderRadiusFull = "9999px";
  export const FuelFontFamilyBase = "'Open Sans', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', Helvetica, Arial, 'Nimbus Sans L', 'FreeSans', 'Liberation Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'";
  export const FuelFontFamilyHeading = "'Open Sans', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', Helvetica, Arial, 'Nimbus Sans L', 'FreeSans', 'Liberation Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'";
  export const FuelFontFamilyJdSansProMedium = "'JDSansPro-Medium', 'Open Sans', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', Helvetica, Arial, 'Nimbus Sans L', 'FreeSans', 'Liberation Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'";
  export const FuelFontFamilyJdSansProBold = "'JDSansPro-Bold', 'Open Sans', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', Helvetica, Arial, 'Nimbus Sans L', 'FreeSans', 'Liberation Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'";
  export const FuelFontWeightBase = "400";
  export const FuelFontWeightRegular = "400";
  export const FuelFontWeightSemibold = "600";
  export const FuelFontWeightBold = "700";
  export const FuelFontSizeBase = "1rem";
  export const FuelFontSizeXs = ".75rem";
  export const FuelFontSizeSm = ".875rem";
  export const FuelFontSizeMd = "1rem";
  export const FuelFontSizeLg = "1.125rem";
  export const FuelFontSizeXl = "1.25rem";
  export const FuelFontSize2xl = "1.5rem";
  export const FuelFontSize3xl = "1.875rem";
  export const FuelFontSize4xl = "2.25rem";
  export const FuelFontSize5xl = "3rem";
  export const FuelFontSize6xl = "3.5rem";
  export const FuelFontSizeHeading1 = "1.5rem";
  export const FuelFontSizeHeading2 = "1.25rem";
  export const FuelFontSizeHeading3 = "1.125rem";
  export const FuelFontSizeHeading4 = "1rem";
  export const FuelFontSizeHeading5 = ".875rem";
  export const FuelFontSizeHeading6 = ".875rem";
  export const FuelFontSizeBody = "1rem";
  export const FuelFontSizeIcon = ".625rem";
  export const FuelLineHeightBase = "1.5rem";
  export const FuelLineHeightXs = "1rem";
  export const FuelLineHeightSm = "1.25rem";
  export const FuelLineHeightMd = "1.5rem";
  export const FuelLineHeightLg = "1.75rem";
  export const FuelLineHeightXl = "1.75rem";
  export const FuelLineHeight2xl = "2rem";
  export const FuelLineHeight3xl = "2.25rem";
  export const FuelLineHeight4xl = "2.5rem";
  export const FuelLineHeight5xl = "3rem";
  export const FuelLineHeight6xl = "3.5rem";
  export const FuelShadowBase = "0px 0px 5px 0px rgba(27, 27, 27, .05), 0px 1px 2px 0px rgba(27, 27, 27, .15), 0px 0px 0px 1px rgba(51, 51, 51, .05), 0px 1px 3px 0px rgba(51, 51, 51, .15)";
  export const FuelShadowNone = "none";
  export const FuelShadowXs = "0px 2px 4px -1px rgba(0, 0, 0, 0.1)";
  export const FuelShadowSm = "0px 1px 3px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px 0px rgba(0, 0, 0, 0.06)";
  export const FuelShadowMd = "0px 0px 5px 0px rgba(27, 27, 27, .05), 0px 1px 2px 0px rgba(27, 27, 27, .15), 0px 0px 0px 1px rgba(51, 51, 51, .05), 0px 1px 3px 0px rgba(51, 51, 51, .15)";
  export const FuelShadowLg = "0px 4px 6px -1px rgba(27, 27, 27, 0.15), 0px 0px 0px 1px rgba(51, 51, 51, 0.05)";
  export const FuelShadowXl = "0px 1px 10px 0px rgba(27, 27, 27, 0.2), 0px -1px 20px 0px rgba(27, 27, 27, 0.1)";
  export const FuelShadow2xl = "0px 26px 80px 0px rgba(27, 27, 27, 0.2), 0px 0px 1px 0px rgba(27, 27, 27, 0.2)";
  export const FuelShadowInsetButton = "inset 0 -1px 1px rgba(0,0,0, .2)";
  export const FuelShadowFocused = "0 0 0 2px #ffffff, 0 0 0 4px #1b1b1b";
export default {
  FuelColorBrandPrimary,
  FuelColorBrandSecondary,
  FuelColorBackgroundActionDefaultBase,
  FuelColorBackgroundActionDefaultHovered,
  FuelColorBackgroundActionDefaultPressed,
  FuelColorBackgroundActionDefaultSelected,
  FuelColorBackgroundActionDefaultSelectedBar,
  FuelColorBackgroundActionPrimaryBase,
  FuelColorBackgroundActionPrimaryHovered,
  FuelColorBackgroundActionPrimaryPressed,
  FuelColorBackgroundActionSecondaryBase,
  FuelColorBackgroundActionSecondaryHovered,
  FuelColorBackgroundActionSecondaryPressed,
  FuelColorBackgroundActionTertiaryBase,
  FuelColorBackgroundActionTertiaryHovered,
  FuelColorBackgroundActionTertiaryPressed,
  FuelColorBackgroundInteractiveDefaultBase,
  FuelColorBackgroundWhite,
  FuelColorBackgroundGray,
  FuelColorBackgroundBrand,
  FuelColorTextLink,
  FuelColorTextLinkHovered,
  FuelColorTextActionDefault,
  FuelColorTextActionPrimary,
  FuelColorTextActionSecondary,
  FuelColorTextActionTertiary,
  FuelColorTextPrimary,
  FuelColorTextSecondary,
  FuelColorTextTertiary,
  FuelColorTextDisabled,
  FuelColorTextBody,
  FuelColorTextHeading,
  FuelColorTextIcon,
  FuelColorTextBrandPrimary,
  FuelColorFocused,
  FuelColorBorderSelected,
  FuelColorBorderBase,
  FuelColorBorderLight,
  FuelColorBorderDark,
  FuelColorAlertSuccessBackground,
  FuelColorAlertSuccessIcon,
  FuelColorAlertSuccessBorder,
  FuelColorAlertErrorBackground,
  FuelColorAlertErrorIcon,
  FuelColorAlertErrorBorder,
  FuelColorAlertInfoBackground,
  FuelColorAlertInfoIcon,
  FuelColorAlertInfoBorder,
  FuelColorAlertWarningBackground,
  FuelColorAlertWarningIcon,
  FuelColorAlertWarningBorder,
  FuelColorGray50,
  FuelColorGray100,
  FuelColorGray200,
  FuelColorGray300,
  FuelColorGray400,
  FuelColorGray500,
  FuelColorGray600,
  FuelColorGray700,
  FuelColorGray800,
  FuelColorGray900,
  FuelColorGray1000,
  FuelColorYellow50,
  FuelColorYellow100,
  FuelColorYellow200,
  FuelColorYellow300,
  FuelColorYellow400,
  FuelColorYellow500,
  FuelColorYellow600,
  FuelColorYellow700,
  FuelColorYellow800,
  FuelColorYellow900,
  FuelColorYellow1000,
  FuelColorGreen50,
  FuelColorGreen100,
  FuelColorGreen200,
  FuelColorGreen300,
  FuelColorGreen400,
  FuelColorGreen500,
  FuelColorGreen600,
  FuelColorGreen700,
  FuelColorGreen800,
  FuelColorGreen900,
  FuelColorGreen1000,
  FuelColorBlack,
  FuelColorWhite,
  FuelColorJdGreen,
  FuelColorJdYellow,
  FuelColorJdCharcoal,
  FuelColorJdConstructionYellow,
  FuelColorChartBrandGreen,
  FuelColorChartBrandYellow,
  FuelColorChartCoriander,
  FuelColorChartNightRider,
  FuelColorChartYellowSea,
  FuelColorChartAthensGrey,
  FuelColorChartRollingStone,
  FuelColorChartCanaryYellow,
  FuelColorChartOliveGreen,
  FuelChipColorBackgroundSelected,
  FuelSpacing0,
  FuelSpacing1,
  FuelSpacing2,
  FuelSpacing3,
  FuelSpacing4,
  FuelSpacing6,
  FuelSpacing8,
  FuelSpacing10,
  FuelSpacing12,
  FuelSpacing16,
  FuelBorderRadiusBase,
  FuelBorderRadiusNone,
  FuelBorderRadiusSm,
  FuelBorderRadiusMd,
  FuelBorderRadiusLg,
  FuelBorderRadiusXl,
  FuelBorderRadius2xl,
  FuelBorderRadiusFull,
  FuelFontFamilyBase,
  FuelFontFamilyHeading,
  FuelFontFamilyJdSansProMedium,
  FuelFontFamilyJdSansProBold,
  FuelFontWeightBase,
  FuelFontWeightRegular,
  FuelFontWeightSemibold,
  FuelFontWeightBold,
  FuelFontSizeBase,
  FuelFontSizeXs,
  FuelFontSizeSm,
  FuelFontSizeMd,
  FuelFontSizeLg,
  FuelFontSizeXl,
  FuelFontSize2xl,
  FuelFontSize3xl,
  FuelFontSize4xl,
  FuelFontSize5xl,
  FuelFontSize6xl,
  FuelFontSizeHeading1,
  FuelFontSizeHeading2,
  FuelFontSizeHeading3,
  FuelFontSizeHeading4,
  FuelFontSizeHeading5,
  FuelFontSizeHeading6,
  FuelFontSizeBody,
  FuelFontSizeIcon,
  FuelLineHeightBase,
  FuelLineHeightXs,
  FuelLineHeightSm,
  FuelLineHeightMd,
  FuelLineHeightLg,
  FuelLineHeightXl,
  FuelLineHeight2xl,
  FuelLineHeight3xl,
  FuelLineHeight4xl,
  FuelLineHeight5xl,
  FuelLineHeight6xl,
  FuelShadowBase,
  FuelShadowNone,
  FuelShadowXs,
  FuelShadowSm,
  FuelShadowMd,
  FuelShadowLg,
  FuelShadowXl,
  FuelShadow2xl,
  FuelShadowInsetButton,
  FuelShadowFocused,
}